import {get, post} from "../APIGateWay";

export async function updateAvatarParent(data) {
    return await post(data, '/account-parent/update-avata')
}
export async function updateAvatar(data) {
    return await post(data, '/user/update')
}

export async function updateProfile(data) {
    return await post(data, '/user/change-info')
}

export async function updateParentProfile(data) {
    return await post(data, '/parent/change-info')
}

export async function updateContact(data) {
    return await post(data, '/parent/change-contact')
}

export async function updatePassword(data) {
    return await post(data, '/password')
}

export async function getProfile(params = {}) {
    return await get(params, '/user/info')
}

export async function getParentProfile(data) {
    return await post(data, '/account-parent/get-user-info')
}

export async function getAvatars() {
    return await get({}, '/user/avatar')
}

export async function getConfig() {
    return await get({}, '/get-config')
}

export async function updateLanguage(data) {
    return await post(data, '/user/update-language')
}

export async function getParentSettings() {
    return await get({}, '/parent/parents-setting')
}

export async function updateSetingNofification(data) {
    return await post(data, '/notification/change')
}

export async function changeGrade(params) {
    return await get(params, '/course/change-grade')
}

export async function generateOTP(data) {
    return await post(data, '/user/generate-otp')
}
export async function verifyOTP(data) {
    return await post(data, '/user/verify-otp')
}

export async function updateAddress(data) {
    return await post(data, '/user/update-address')
}